export const fullNameRegEx = /^[\p{L}~`_',.-]+(?: [\p{L}~`_',.-]+)+$/u;
export const firstLastNameRegEx = /^(?=.*[a-zA-Z])[\p{L}~’',-]+(?: [\p{L}~’',-]+)*$/u;
export const phoneRegEx = /^\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})(\s*x[0-9]+)?$/;
export const emailRegEx =
    /^(?=[a-zA-Z0-9][a-zA-Z0-9@_.+-]{5,253}$)[a-zA-Z0-9_.+-]{1,64}@(?:(?=[a-zA-Z0-9-]{1,63}\.)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.){1,8}[a-zA-Z]{2,63}$/;
